import styled, {CSSProperties, css} from 'styled-components';

import {mixins} from '@edna/components/styles';

import {TMessagePreviewPlacement} from './MessagePreview';
import {MAX_MESSAGE_WIDTH} from './utils';

export const PreviewWrapper = styled.div<{
  width?: CSSProperties['width'];
  placement?: TMessagePreviewPlacement;
}>`
  ${mixins.position({position: 'sticky', left: '48px', top: '100px'})};
  ${mixins.stack({size: '4', justify: 'end'})};
  ${({width = '334px', placement}) => css`
    width: ${width};
    min-width: ${width};
    margin-right: ${placement === 'left' || placement === 'center' ? 'auto' : 0};
    margin-left: ${placement === 'right' || placement === 'center' ? 'auto' : 0};
  `};
`;

export const Icon = styled.div`
  ${mixins.wh('40px')}
  color: ${({theme}) => theme.branding.content.tertiary};
`;

export const Time = styled.span`
  ${mixins.f2};
  ${mixins.position({position: 'relative', bottom: '-2px'})};
  line-height: 16px;
  align-self: end;
  float: right;
  ${({theme: {branding, spacing}}) => css`
    padding-left: ${spacing.s2};
    color: ${branding.content.tertiary};
  `}
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  border-radius: ${({theme}) => theme.borderRadius.br2};
`;

export const MessageWrapper = styled.div`
  width: 100%;
  ${mixins.stack({align: 'center', justify: 'center', size: '1'})};
  ${({theme}) => css`
    background-color: ${theme.palette.grey300};
  `};
`;

type TMessageProps = {
  isInline?: boolean;
  isRtlDirection?: boolean;
};

export const Message = styled.div<TMessageProps>`
  ${mixins.stack({size: '2', align: 'end'})};
  ${mixins.f3};
  line-height: 18px;
  position: relative;
  width: 100%;
  max-width: ${MAX_MESSAGE_WIDTH};
  margin: 40px 34px;
  word-break: break-word;
  white-space: pre-wrap;

  ${({theme, isInline}) => css`
    display: ${isInline ? 'inline-block' : 'flex'};
    padding: ${theme.spacing.s2};
    background-color: ${theme.palette.white};
    border-radius: ${theme.borderRadius.br1};
  `};

  ${({isRtlDirection}) =>
    isRtlDirection &&
    css`
      direction: rtl;

      ${Time} {
        float: left;
      }
    `}
`;
